import { useT } from '@/shared/lib/i18n';
import { Button } from '@/shared/ui';

export type ReadyToVoteCtaProps = {
  canReadyToVote: boolean;
  onReadyToVote: () => void;
};

/**
 * Open-vote affordance shown under the speaking ring. Host (or standalone)
 * gets the button; non-host online players see a "waiting for host" line.
 */
export const ReadyToVoteCta = ({ canReadyToVote, onReadyToVote }: ReadyToVoteCtaProps) => {
  const t = useT();
  if (canReadyToVote) {
    return (
      <Button variant="orange" onClick={onReadyToVote}>
        {t('round.speaking.ready_to_vote')}
      </Button>
    );
  }
  return (
    <p className="text-center text-[13px] text-text-dim italic">
      {t('online.discuss.waiting_host')}
    </p>
  );
};
